<form (ngSubmit)="onSubmit()" [formGroup]="formEmployee">
  <p-dialog header="Añadir Empleado" [modal]="true" [(visible)]="visible" (onHide)="closeDialog()" [maximizable]="true"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '50vw' }">
    <div class="flex flex-column gap-4 mt-3">
      <!-- Sección Información Personal -->
      <div>
        <div class="text-900 font-bold text-xl mb-3 flex align-items-center gap-2">
          <i class="pi pi-user text-primary"></i> Información Personal
        </div>
        <div class="formgrid grid">
          <div class="col-12 md:col-6">
            <app-input name="username" formControlName="username" label="Nombre*" type="text-required"
              [customErrorMessages]="{ required: 'Este campo es requerido' }" />
          </div>
          <div class="col-12 md:col-6">
            <app-input name="surname" formControlName="surname" label="Apellidos" />
          </div>
        </div>
      </div>

      <p-divider></p-divider>

      <!-- Sección Contacto -->
      <div>
        <div class="text-900 font-bold text-xl mb-3 flex align-items-center gap-2">
          <i class="pi pi-phone text-primary"></i> Contacto
        </div>
        <div class="formgrid grid">
          <div class="col-12 md:col-6">
            <app-input name="email" formControlName="email" label="Email*" type="email-required"
              [formControl]="formUtilities.getControl(formEmployee, 'email')"
              [customErrorMessages]="{ required: 'El email es requerido', email: 'Ingresa un email válido' }" />
          </div>
          <div class="col-12 md:col-6">
            <app-input name="phone" formControlName="phone" label="Teléfono" type="number" />
          </div>
        </div>
      </div>

      <p-divider></p-divider>

      <!-- Sección Configuración -->
      <div>
        <div class="text-900 font-bold text-xl mb-3 flex align-items-center gap-2">
          <i class="pi pi-cog text-primary"></i> Configuración
        </div>
        <div class="field">
          <label for="categories" class="font-semibold block mb-2">Categorías</label>
          <p-multiSelect id="categories" name="categories" [options]="categories()" formControlName="categories"
            optionLabel="attributes.name" optionValue="id" placeholder="Seleccione Categorías" appendTo="body"
            class="w-full" />
        </div>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <div class="flex justify-content-end gap-2">
        <p-button label="Cancelar" severity="secondary" icon="pi pi-times" (onClick)="closeDialog()"
          [outlined]="true" />
        <p-button label="Guardar Empleado" icon="pi pi-check" type="submit" [disabled]="formEmployee.invalid" />
      </div>
    </ng-template>
  </p-dialog>
</form>